import { render, staticRenderFns } from "./SupplierRawMaterialAllergens.vue?vue&type=template&id=6553b87f&scoped=true&"
import script from "./SupplierRawMaterialAllergens.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialAllergens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6553b87f",
  null
  
)

export default component.exports